import styled from "@emotion/styled";
import { sdkTouchOptimizedStyles } from "scmp-sdk/components/follow-button/styles";

export const Container = styled.div`
  inline-size: fit-content;

  ${sdkTouchOptimizedStyles}
`;
